<div class="login-container">
    <div class="login-background">
        <div class="shape"></div>
        <div class="shape"></div>
    </div>
    <div class="login-content">
        <div class="logo-container">
            <img src="assets/images/nri-logo-white.png" alt="logo" class="logo pulse">
        </div>
  <div class="signup-width">
    <div class="row">
      <div class="signup-left">
        <h2>New User - Sign Up</h2>
        <p class="left-text">
          Join our platform to connect NRIs with trusted service providers
        </p>
        <div class="row">
          <div class="position-relative col-md-6 ignup-left">
            <div class="position-relative">
              <app-text-input
                label="First Name"
                [control]="getControl('firstName')"
              ></app-text-input>
            </div>
          </div>
          <div class="position-relative col-md-6">
            <div class="position-relative">
              <app-text-input
                label="Last Name"
                [control]="getControl('lastName')"
              ></app-text-input>
            </div>
          </div>
          <div class="position-relative col-md-6">
            <div class="position-relative">
              <app-text-input
                label="Email Address"
                [control]="getControl('email')"
              ></app-text-input>
            </div>
          </div>
          <div class="position-relative col-md-6">
            <div class="position-relative">
              <app-text-input
                label="Phone Number"
                [control]="getControl('mobileNumber')"
              ></app-text-input>
            </div>
          </div>
          <div class="mb-0 position-relative col-md-6">
            <div class="position-relative password-wrapper">
              <div style="width: 100%">
                <app-text-input
                  label="Password"
                  [type]="isPasswordVisible ? 'text' : 'password'"
                  [control]="getControl('password')"
                 
                >
                </app-text-input>
                <i
                  class="fa"
                  [ngClass]="isPasswordVisible ? 'fa-eye' : 'fa-eye-slash'"
                  (click)="togglePasswordVisibility()"
                ></i>
                <div password-align>
     <div *ngIf="passwordErrors?.['noLowercase']" class="pwd-format-text ">Must contain a lowercase letter</div>
<div *ngIf="passwordErrors?.['noUppercase']" class="pwd-format-text ">Must contain an uppercase letter</div>
<div *ngIf="passwordErrors?.['noNumber']" class="pwd-format-text ">Must contain a number</div>
<div *ngIf="passwordErrors?.['noSpecialChar']" class="pwd-format-text ">Must contain a special character (&#64;$!%*?&)</div>
<div *ngIf="passwordErrors?.['tooShort']" class="pwd-format-text ">Minimum 8 characters required</div>
    </div>
                <!-- <div
                  *ngIf="getControl('password').invalid && getControl('password').touched"
                  class="text-danger mt-1"
                  style="font-size: 13px;"
                >
                  
                  <ul class="pwd-format-text">
                    <span class="pwd-text" *ngIf="getControl('password').invalid">Password must contain:</span>
                    <li [class.valid]="hasLowercase()">At least 1 lowercase letter</li>
                    <li [class.valid]="hasUppercase()">At least 1 uppercase letter</li>
                    <li [class.valid]="hasNumber()">At least 1 number (0-9)</li>
                    <li [class.valid]="hasSpecialChar()">At least 1 special character. Allowed characters are (&#64;$!%*?&)</li>
                    <li [class.valid]="hasMaxLength()">Minimum 8 characters long</li>
                  </ul>
                </div> -->
              </div>
            </div>
          </div>
          <div class="mb-0 position-relative col-md-6">
            <div class="position-relative password-wrapper">
              <div style="width: 100%">
                <app-text-input
                  label="Confirm Password"
                  [type]="isConfirmPasswordVisible ? 'text' : 'password'"
                  [control]="getControl('confirmPassword')"
                >
                </app-text-input>
                <i
                  class="fa"
                  [ngClass]="
                    isConfirmPasswordVisible ? 'fa-eye' : 'fa-eye-slash'
                  "
                  (click)="toggleConfirmPasswordVisibility()"
                ></i>
                <div
                  *ngIf="getControl('confirmPassword').invalid && getControl('confirmPassword').touched"
                  class="text-danger mt-1"
                  style="font-size: 13px;"
                >
                  <!-- <div *ngIf="getControl('confirmPassword').hasError('required')">
                    Confirm Password is required
                  </div> -->
                </div>
                <div
                  *ngIf="
                    passwordsMismatch && getControl('confirmPassword').dirty
                  "
                  class="text-danger mt-1"
                  style="font-size: 13px;"
                >
                  Password and Confirm Password do not match
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="signup-btn mt-4">
          <button
            class="btn btn-primary mb-4 width-100"
            (click)="signUp()"
            [disabled]="loading"
          >
            <span class="fa-spin-position">
              Sign Up
              <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
            </span>
          </button>
        </div>
        <span class="mt-1 mb-1 text-center signin-link-bold">
          Already have an account?
          <a [routerLink]="['/login']" class="signin-link">Sign In</a>
        </span>
      </div>
      <!-- <div class="col-lg-6 col-md-6 signup-right">
        <div class="text-center">
          <img
            src="assets/images/signup.png"
            alt="signup"
            class="signup-image"
          />
          <div class="ml-16">
            <h3>Connect. Trust. Succeed.</h3>
            <p class="right-text">
              Join thousands of NRIs and service providers building trusted
              relationships across borders. Your journey to seamless
              international services starts here.
            </p>
            <ul class="features-list">
              <li>
                <i class="fa fa-shield" aria-hidden="true"></i>Verified Service
                Providers
              </li>
              <li>
                <i class="fa fa-clock" aria-hidden="true"></i>24/7 Customer
                Support
              </li>
              <li>
                <i class="fa fa-star" aria-hidden="true"></i>Trusted by 50,000+
                Users
              </li>
            </ul>
          </div>
        </div>
      </div> -->
    </div>
  </div>
  </div>
</div>
